import React, { FunctionComponent } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { Mutation } from 'react-apollo'

const eventSetReportMutation = require('./event-set-report.gql')
const eventReportMutation = require('./event-report.gql')

const style = require('./EventReport.css')
import FlagIcon from 'assets/Icons/flag.svg'
import locale from './locale'

interface Props {
  slug: String,
  loading: boolean,
  isEventSet: boolean,
  isEventReported: boolean,
  setIsEventReported: Function,
  available: boolean,
}

export const EventReportComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  slug,
  intl,
  loading,
  isEventSet,
  isEventReported,
  setIsEventReported,
  available,
}) => {
  if (loading) return null

  return available && (
    <Mutation
      mutation={isEventSet ? eventSetReportMutation : eventReportMutation}
      onCompleted={() => setIsEventReported(true)}
      variables={{ id: slug }}
    >
      {report => (
        <button
          disabled={isEventReported}
          className={style.reportEventButton}
          onClick={() => report()}
        >
          <FlagIcon className={style.flagIcon} />
          {intl.formatMessage(locale.reportEvent)}
        </button>
      )}
    </Mutation>
  )
}

export const EventReport = injectIntl(EventReportComponent)
